import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'filterRetailers'
})

export class FilterRetailersPipe implements PipeTransform {

    transform(value: Array<any>, searchTerm: string) {
        if (value && searchTerm) {
            let filtered = value.filter(x => {
                return x.retailerNumber.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    x.name.toLowerCase().includes(searchTerm.toLowerCase())
            });
            return filtered;
        } else {
            return value;
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/pipes/filter-retailers.pipe.ts